import { Box, HStack, Text } from '@rbilabs/universal-components';

import { DELIVERY_PROGRESS_COLOR } from './constants';

export const StatusMessage = Text.withConfig({
  variant: 'copyTwo',
  fontSize: 'sm',
  color: Styles.color.grey.one,
});

export const StatusMessageContainer = Box.withConfig({
  focusable: true,
});

export const ProgressList = HStack.withConfig({
  justifyContent: 'space-between',
  marginTop: '$5',
  marginBottom: '$4',
  width: 'full',
});

export const ProgressListItem = Box.withConfig({
  width: '70px',
  alignItems: 'center',
  _text: {
    color: Styles.color.grey.two,
    fontSize: 'xs',
    lineHeight: 'xs',
    textAlign: 'center',
  },
  focusable: true,
});

export const ProgressListItemHeader = ProgressListItem.withConfig<{ isActive?: boolean }>(p => ({
  _text: {
    color: p.isActive ? DELIVERY_PROGRESS_COLOR : Styles.color.black,
  },
}));
